import React, {useEffect, useState} from "react";
import {
  Form,
  Row,
  Col,
  Space,
  DatePicker,
  Input,
  Button,
  Spin,
  message,
} from "antd";
import {employeeService} from "api"
import {InputFields} from "components/common";
import {dataFields} from "./config";

import {useAppSelector} from "../../../../../../../redux/hooks";
import Notification from "../../../../../../../components/common/notification/notification";


const FormRest = props => {
  const {data, closeModal, type, getListApi, setCurrentPage} = props;
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  let idEmp = useAppSelector(state => state.employeesReducer.idEmp);
  useEffect(() => {
    form.resetFields();

    if (idEmp) {
      form.setFieldsValue({ id: idEmp });
    } else {
      Notification("error", "Chưa có thông tin nhân viên ");

    }
  }, [idEmp]);
  const remoteEmp = async () => {
    setLoading(true);
    try {
      const params = {
        ...form.getFieldsValue(), // Lấy giá trị từ form
        id: idEmp, // Thêm trường id vào params
      };

      const res = await employeeService.statusEmp(params);

      Notification("success", "xác nhận nghỉ việc thành công");
      setLoading(false);
      closeModal();
      form.resetFields();
      await getListApi();
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã có lỗi khi xác nhận nghỉ việc  ");

    }
  };

  const onFinish = (values) => {
    remoteEmp();
  };
  return (
    <div>
      <Spin spinning={loading}>
        <Form form={form} onFinish={onFinish} >
          <Space direction="vertical" style={{width: "100%"}}>
            <Row gutter={[40, 16]}>
              <InputFields data={dataFields}></InputFields>
            </Row>
            <Row justify="end" style={{ marginTop: 12 }}>
              <Col>
                <Space>
                  <Button onClick={closeModal} style={{ backgroundColor: "red", borderColor: "red" , color: "white"  }}>Hủy bỏ</Button>
                  <Button htmlType="submit" type="primary" >
                    Xác nhận nghỉ việc
                  </Button>
                </Space>{" "}
              </Col>
            </Row>
          </Space>
        </Form>
      </Spin>
    </div>
  );
};
export default FormRest;
